/* Format days lang "es" */
export default (value) => {
    let days = {
        '0' : 'Lunes',
        '1' : 'Martes',
        '2' : 'Miércoles',
        '3' : 'Jueves',
        '4' : 'Viernes',
        '5' : 'Sábado',
        '6' : 'Domingo'
    }
    return days[String(value)];
}


// WEBPACK FOOTER //
// ./src/filters/formatDay.js